import React from 'react'
import PropTypes from 'prop-types'

import './TextAreaInput.scss'

const TextAreaInput = ({ id, label, placeholder, value, onChange, name, className, ...props }) => (
  <div className={`text-area-input ${className}`}>
    {
      label &&
      <label htmlFor={id || name}>{label}</label>
    }
    <textarea
      placeholder={placeholder || ''}
      id={name}
      value={value}
      name={name}
      onChange={onChange}
      {...props}
    />
  </div>
)

TextAreaInput.defaultProps = {
  id: '',
  placeholder: '',
  className: '',
  name: '',
  label: '',
  value: '',
  onChange: null,
}

TextAreaInput.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default TextAreaInput



// WEBPACK FOOTER //
// ./src/browser/components/fields/TextAreaInput.js